import { Link, RadioField, RadioInput } from '@flos/react-ui';
import type { AttributeChangeProps } from '../../../types';
import { useState } from 'react';
import { useHippoText } from '../../../../../hooks/useHippoText';
import { type YesNo_Top } from 'gw-edge-client/dist/types/dto/pc/typekey';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { isOpcDataFilledAtom } from '../../../../../recoil/atoms/isOpcDataFilledAtom';
import { infoModalVariantOpcAtom } from '../../../../../recoil/atoms/infoModalVariantOpcAtom';
import { opcInfoAtom } from '../../../../../recoil/atoms/opcInfoAtom';
import { isOpcFetchingAtom } from '../../../../../recoil/atoms/isOpcFetchingAtom';

const TravelChangeFlavour = ({ updateCoverableAttribute }: AttributeChangeProps): JSX.Element => {
    const opcInfo = useRecoilValue(opcInfoAtom);
    const getHippoText = useHippoText();
    const isOpcFetching = useRecoilValue(isOpcFetchingAtom);
    const setIsOpcDataFilled = useSetRecoilState(isOpcDataFilledAtom);
    const setInformationModalVariant = useSetRecoilState(infoModalVariantOpcAtom);
    const hippoText = {
        modalTitle: getHippoText('DSS-COVERABLE-INFORMATION-STEP-ADDRESS-HEADER'),
        moreThanOnePersonOption: getHippoText(
            'DSS-COVERABLE-INFORMATION-STEP-ADDRESS-MULTIPLE-PEOPLE'
        ),
        onePersonOption: getHippoText('DSS-COVERABLE-INFORMATION-STEP-ADDRESS-ONE-PERSON'),
        permanentResidentModalHeader: getHippoText('DSS-TRAVEL-COVERABLE-INFO-STEP-MODAL-HEADER'),
        permanentRedisentModalDescription: getHippoText(
            'DSS-TRAVEL-COVERABLE-INFO-STEP-MODAL-DESCRIPTION'
        )
    };
    const travelFlavour = opcInfo.productName === 'top_tra_individual' ? 'No' : 'Yes';
    const [isHousehold, setIsHousehold] = useState<YesNo_Top>(travelFlavour);
    const handleTravelFlavourChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const { value } = event.target;
        setIsOpcDataFilled(value !== travelFlavour);
        updateCoverableAttribute({
            moreThanOnePersonInHousehold: value as YesNo_Top
        });
        setIsHousehold(value as YesNo_Top);
    };

    return (
        <>
            <RadioField
                value={isHousehold}
                onChange={handleTravelFlavourChange}
                disabled={isOpcFetching}
            >
                <RadioInput value="No" label={hippoText.onePersonOption} />
                <RadioInput value="Yes" label={hippoText.moreThanOnePersonOption} />
            </RadioField>
            <Link
                className="u-color-primary-2-base u-text-right"
                onClick={() => {
                    setInformationModalVariant('traNumberInHousehold');
                }}
            >
                <ul className="u-text-right">{hippoText.permanentResidentModalHeader}</ul>
            </Link>
        </>
    );
};

export default TravelChangeFlavour;
